import {FullStory} from '@vio/core/src/analytics/types/FullStory'

declare let FS: FullStory

export const getFullStoryObject = () => {
  return typeof FS === 'undefined' ? undefined : FS
}

export const getFullStorySessionUrl = () => {
  const fs = getFullStoryObject()
  if (fs) {
    const fullStorySessionUrl = fs.getCurrentSessionURL?.(true)

    // fsrelay.vio.com is the fullstory relay server, we need to replace it with the fullstory session host
    // this is not supported by the fullstory v1 configs, so we need to replace it with the fullstory session host
    return fullStorySessionUrl?.replace(
      'https://app.fsrelay.vio.com',
      'https://app.fullstory.com'
    )
  }
}
export const trackFullStoryEvent = <T>(
  eventName: string,
  eventProperties: T
) => {
  getFullStoryObject()?.event(
    eventName,
    eventProperties as Record<string, unknown>
  )
}
